import { render, staticRenderFns } from "./scopri-app-plus.vue?vue&type=template&id=0f2ad780"
import script from "./scopri-app-plus.vue?vue&type=script&lang=js"
export * from "./scopri-app-plus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports